// Arabic translations for the entire application
const translations = {
  // Navigation
  nav: {
    dashboard: 'لوحة التحكم',
    articles: 'المقالات',
    articleEditor: 'محرر المقالات',
    projects: 'المشاريع',
    projectForm: 'نموذج المشروع',
    subUnions: 'الاتحادات الفرعية',
    subUnionForm: 'نموذج الاتحاد الفرعي',
    cities: 'المدن',
    offices: 'المكاتب',
    officeForm: 'نموذج المكتب',
    settings: 'الإعدادات',
    help: 'المساعدة والدعم',
    profile: 'الملف الشخصي',
    signOut: 'تسجيل الخروج',
    more: 'المزيد',
    overview: 'نظرة عامة',
    contentManagement: 'إدارة المحتوى',
    organization: 'التنظيم',
    management: 'الإدارة',
    navigation: 'التنقل'
  },

  // Common UI
  common: {
    search: 'بحث',
    filter: 'تصفية',
    filters: 'التصفيات',
    clear: 'مسح',
    clearAll: 'مسح الكل',
    apply: 'تطبيق',
    cancel: 'إلغاء',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    add: 'إضافة',
    remove: 'إزالة',
    update: 'تحديث',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    confirm: 'تأكيد',
    loading: 'جاري التحميل...',
    processing: 'جاري المعالجة...',
    noResults: 'لا توجد نتائج',
    noData: 'لا توجد بيانات',
    selectAll: 'تحديد الكل {count} {items}',
    deselectAll: 'إلغاء التحديد',
    selected: 'محدد',
    actions: 'الإجراءات',
    action: 'إجراء',
    status: 'الحالة',
    category: 'الفئة',
    date: 'التاريخ',
    time: 'الوقت',
    author: 'الكاتب',
    title: 'العنوان',
    description: 'الوصف',
    preview: 'معاينة',
    duplicate: 'نسخ',
    publish: 'نشر',
    unpublish: 'إلغاء النشر',
    draft: 'مسودة',
    published: 'منشور',
    scheduled: 'مجدول',
    view: 'عرض',
    show: 'إظهار',
    hide: 'إخفاء',
    more: 'المزيد',
    less: 'أقل',
    all: 'الكل',
    none: 'لا شيء',
    yes: 'نعم',
    no: 'لا',
    ok: 'موافق',
    retry: 'إعادة المحاولة',
    refresh: 'تحديث',
    export: 'تصدير',
    import: 'استيراد',
    download: 'تحميل',
    upload: 'رفع',
    choose: 'اختر',
    select: 'تحديد',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    phone: 'الهاتف',
    address: 'العنوان',
    language: 'اللغة',
    languages: 'اللغات',
    from: 'من',
    to: 'إلى',
    dateRange: 'نطاق التاريخ',
    showing: 'عرض',
    of: 'من',
    results: 'النتائج',
    result: 'نتيجة',
    page: 'صفحة',
    pages: 'صفحات',
    total: 'المجموع',
    empty: 'فارغ',
    required: 'مطلوب',
    optional: 'اختياري',
    error: 'خطأ',
    success: 'نجاح',
    warning: 'تحذير',
    info: 'معلومات',
    unknown: 'غير معروف',
    unknownAuthor: 'مؤلف غير معروف',
    untitled: 'بدون عنوان',
    untitledArticle: 'مقال بدون عنوان'
  },

  // Dashboard
  dashboard: {
    title: 'لوحة التحكم',
    welcome: 'مرحباً بك في نظام إدارة الإتحاد العام لطلبة سوريا',
    systemStatus: 'النظام يعمل بشكل طبيعي',
    lastUpdate: 'آخر تحديث',
    activeUsers: 'مستخدم نشط',
    uptime: 'وقت التشغيل',
    storageUsed: 'مساحة مستخدمة',
    subUnions: 'الاتحادات الفرعية',
    publishedArticles: 'المقالات المنشورة',
    activeProjects: 'المشاريع النشطة',
    registeredCities: 'المدن المسجلة'
  },

  // Articles
  articles: {
    management: 'إدارة المقالات',
    managementDescription: 'إدارة ونشر المقالات والأخبار والإعلانات لمجتمع الإتحاد العام لطلبة سوريا',
    createArticle: 'إنشاء مقال',
    searchArticles: 'البحث في المقالات بالعنوان أو المحتوى أو المؤلف...',
    allCategories: 'جميع الفئات',
    allStatus: 'جميع الحالات',
    allAuthors: 'جميع المؤلفين',
    allLanguages: 'جميع اللغات',
    news: 'أخبار',
    events: 'فعاليات',
    announcements: 'إعلانات',
    article: 'مقال',
    articles: 'مقالات',
    articleCount: 'مقال',
    articlesCount: 'مقالات',
    noArticlesFound: 'لم يتم العثور على مقالات',
    noArticlesDescription: 'ابدأ بإنشاء أول مقال لك أو قم بتعديل المرشحات الخاصة بك',
    selectAllArticles: 'تحديد جميع المقالات',
    articlesSelected: 'مقالات محددة',
    chooseAction: 'اختر إجراء...',
    publishArticles: 'نشر المقالات',
    unpublishArticles: 'إلغاء نشر المقالات',
    moveToDraft: 'نقل إلى المسودة',
    deleteArticles: 'حذف المقالات',
    exportArticles: 'تصدير المقالات',
    duplicateArticles: 'نسخ المقالات',
    articleSelected: 'مقال محدد',
    articlesSelectedPlural: 'مقالات محددة',
    chooseAction: 'اختر إجراء...',
    chooseActionToApply: 'اختر إجراء لتطبيقه على العناصر المحددة',
    publishArticles: 'نشر المقالات',
    unpublishArticles: 'إلغاء نشر المقالات',
    moveToDraft: 'نقل إلى المسودة',
    deleteArticles: 'حذف المقالات',
    exportArticles: 'تصدير المقالات',
    duplicateArticles: 'نسخ المقالات',
    deleteWarning: 'لا يمكن التراجع عن هذا الإجراء. سيتم حذف المقالات نهائياً.',
    publishInfo: 'سيتم جعل المقالات المحددة عامة ومرئية للمستخدمين.',
    unpublishInfo: 'سيتم إخفاء المقالات المحددة عن العرض العام.',
    draftInfo: 'سيتم نقل المقالات المحددة إلى حالة المسودة.',
    exportInfo: 'سيتم تصدير المقالات كملف قابل للتحميل.',
    duplicateInfo: 'سيتم إنشاء نسخ من المقالات المحددة كمسودات.',
    published: 'منشور',
    draft: 'مسودة',
    scheduled: 'مجدول',
    compact: 'مضغوط',
    comfortable: 'مريح',
    spacious: 'واسع',
    hasBeenDuplicated: 'تم نسخ المقال "{title}" بنجاح',
    hasBeenPublished: 'تم نشر المقال "{title}"',
    hasBeenUnpublished: 'تم إلغاء نشر المقال "{title}"',
    haveBeenPublished: 'تم نشر {count} مقالات',
    haveBeenUnpublished: 'تم إلغاء نشر {count} مقالات',
    haveBeenMovedToDraft: 'تم نقل {count} مقالات إلى المسودة',
    haveBeenDeleted: 'تم حذف {count} مقالات',
    haveBeenExported: 'تم تصدير {count} مقالات',
    haveBeenDuplicated: 'تم نسخ {count} مقالات',
    failedToLoad: 'فشل تحميل المقالات. يرجى المحاولة مرة أخرى.',
    failedToUpdateStatus: 'فشل تحديث حالة المقال. يرجى المحاولة مرة أخرى.',
    failedToPerformAction: 'فشل تنفيذ الإجراء. يرجى المحاولة مرة أخرى.',
    unknownAction: 'إجراء غير معروف.',
    copy: 'نسخة'
  },

  // Projects
  projects: {
    management: 'إدارة المشاريع',
    createProject: 'إنشاء مشروع',
    project: 'مشروع',
    projects: 'مشاريع',
    active: 'نشط',
    completed: 'مكتمل',
    planned: 'مخطط',
    onHold: 'متوقف',
    failedToLoad: 'فشل في تحميل المشاريع. يرجى المحاولة مرة أخرى.'
  },

  // Cities
  cities: {
    management: 'إدارة المدن',
    city: 'مدينة',
    cities: 'مدن',
    addCity: 'إضافة مدينة',
    editCity: 'تعديل مدينة',
    deleteCity: 'حذف مدينة'
  },

  // Offices
  offices: {
    management: 'إدارة المكاتب',
    office: 'مكتب',
    offices: 'مكاتب',
    createOffice: 'إنشاء منصب مكتبي',
    position: 'المنصب',
    positions: 'المناصب'
  },

  // Sub-Unions
  subUnions: {
    management: 'إدارة الاتحادات الفرعية',
    subUnion: 'اتحاد فرعي',
    subUnions: 'الاتحادات الفرعية',
    createSubUnion: 'إنشاء اتحاد فرعي',
    addSubUnion: 'إضافة اتحاد فرعي'
  },

  // Login
  login: {
    title: 'تسجيل الدخول',
    subtitle: 'مرحباً بك في لوحة التحكم',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    signIn: 'تسجيل الدخول',
    signingIn: 'جاري تسجيل الدخول...',
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    emailNotConfirmed: 'يرجى تأكيد بريدك الإلكتروني أولاً',
    tooManyRequests: 'محاولات كثيرة، يرجى المحاولة بعد قليل',
    loginError: 'خطأ في تسجيل الدخول',
    unexpectedError: 'حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى',
    verifying: 'جاري التحقق...',
    demoCredentials: 'بيانات تسجيل الدخول التجريبية',
    useDemoCredentials: 'استخدم هذه البيانات للدخول إلى النظام كمدير'
  },

  // Breadcrumbs
  breadcrumbs: {
    dashboard: 'لوحة التحكم',
    citiesManagement: 'إدارة المدن',
    subUnionsManagement: 'إدارة الاتحادات الفرعية',
    subUnionForm: 'نموذج الاتحاد الفرعي',
    articlesManagement: 'إدارة المقالات',
    articleEditor: 'محرر المقالات',
    projectsManagement: 'إدارة المشاريع',
    projectForm: 'نموذج المشروع',
    officesManagement: 'إدارة المكاتب',
    officeForm: 'نموذج المكتب',
    settings: 'الإعدادات',
    help: 'المساعدة والدعم',
    profile: 'الملف الشخصي'
  },

  // Search
  search: {
    placeholder: 'البحث في الصفحات أو الإجراءات أو المحتوى...',
    noResults: 'لم يتم العثور على نتائج لـ',
    trySearching: 'حاول البحث عن الصفحات أو الإجراءات أو المحتوى',
    pages: 'الصفحات',
    quickActions: 'الإجراءات السريعة',
    recent: 'حديث',
    navigate: 'تنقل',
    select: 'اختر',
    close: 'إغلاق',
    results: 'نتائج',
    toSearch: 'للبحث',
    createNewArticle: 'إنشاء مقال جديد',
    createNewProject: 'إنشاء مشروع جديد',
    addSubUnion: 'إضافة اتحاد فرعي',
    createOfficePosition: 'إنشاء منصب مكتبي',
    openSettings: 'فتح الإعدادات',
    getHelp: 'الحصول على المساعدة',
    mainOverview: 'نظرة عامة رئيسية',
    manageArticles: 'إدارة المقالات والمنشورات',
    createAndEditArticles: 'إنشاء وتعديل المقالات',
    manageUnionProjects: 'إدارة مشاريع الاتحاد',
    createNewProjects: 'إنشاء مشاريع جديدة',
    manageSubUnionBranches: 'إدارة فروع الاتحادات الفرعية',
    createNewSubUnions: 'إنشاء اتحادات فرعية جديدة',
    manageCityLocations: 'إدارة مواقع المدن',
    manageOfficePositions: 'إدارة المناصب المكتبية',
    createNewOfficePositions: 'إنشاء مناصب مكتبية جديدة',
    startWritingNewArticle: 'ابدأ بكتابة مقال جديد',
    initializeNewProject: 'تهيئة مشروع جديد',
    registerNewSubUnion: 'تسجيل اتحاد فرعي جديد',
    defineNewOfficeRole: 'تعريف دور مكتبي جديد',
    configureSystemSettings: 'تكوين إعدادات النظام',
    accessHelpDocumentation: 'الوصول إلى وثائق المساعدة'
  },

  // Notifications
  notifications: {
    notifications: 'الإشعارات',
    markAllAsRead: 'تحديد الكل كمقروء',
    noNotifications: 'لا توجد إشعارات',
    viewAll: 'عرض الكل'
  },

  // Profile
  profile: {
    administrator: 'المدير',
    admin: 'مدير'
  },

  // Sidebar
  sidebar: {
    adminPanel: 'لوحة التحكم',
    syrianStudentUnion: 'الإتحاد العام لطلبة سوريا',
    toggleSidebar: 'تبديل الشريط الجانبي',
    mainOverview: 'نظرة عامة رئيسية',
    manageArticles: 'إدارة المقالات والمنشورات',
    createAndEditArticles: 'إنشاء وتعديل المقالات',
    manageUnionProjects: 'إدارة مشاريع الاتحاد',
    createNewProjects: 'إنشاء مشاريع جديدة',
    manageCityLocations: 'إدارة مواقع المدن',
    manageSubUnionBranches: 'إدارة فروع الاتحادات الفرعية',
    createNewSubUnions: 'إنشاء اتحادات فرعية جديدة',
    manageOfficePositions: 'إدارة المناصب المكتبية',
    createNewOfficePositions: 'إنشاء مناصب مكتبية جديدة'
  },

  // Date/Time
  dateTime: {
    today: 'اليوم',
    yesterday: 'أمس',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    thisYear: 'هذا العام',
    lastYear: 'العام الماضي',
    allTime: 'كل الوقت'
  },

  // Form
  form: {
    save: 'حفظ',
    cancel: 'إلغاء',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    update: 'تحديث',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    finish: 'إنهاء',
    required: 'مطلوب',
    optional: 'اختياري',
    invalid: 'غير صحيح',
    saved: 'تم الحفظ',
    saving: 'جاري الحفظ...',
    autoSaved: 'تم الحفظ التلقائي',
    lastAutoSave: 'آخر حفظ تلقائي',
    error: 'خطأ',
    success: 'نجاح',
    warning: 'تحذير'
  },

  // Errors
  errors: {
    generic: 'حدث خطأ ما',
    network: 'خطأ في الاتصال بالشبكة',
    notFound: 'الصفحة غير موجودة',
    unauthorized: 'غير مصرح به',
    forbidden: 'محظور',
    serverError: 'خطأ في الخادم',
    tryAgain: 'يرجى المحاولة مرة أخرى',
    contactSupport: 'يرجى الاتصال بالدعم'
  },

  // 404
  notFound: {
    title: '404 - الصفحة غير موجودة',
    message: 'عذراً، الصفحة التي تبحث عنها غير موجودة.',
    backToDashboard: 'العودة إلى لوحة التحكم',
    goHome: 'العودة إلى الصفحة الرئيسية'
  },

  // Article Editor
  articleEditor: {
    title: 'محرر المقالات',
    description: 'إنشاء وتحرير المقالات متعددة اللغات بمحتوى غني',
    publication: 'النشر',
    hideSettings: 'إخفاء الإعدادات',
    showSettings: 'إظهار الإعدادات',
    saveDraft: 'حفظ كمسودة',
    preview: 'معاينة',
    publishArticle: 'نشر المقال',
    updateArticle: 'تحديث المقال',
    updateSchedule: 'تحديث الجدولة',
    submitForReview: 'إرسال للمراجعة',
    schedulePublication: 'جدولة النشر',
    updateScheduleButton: 'تحديث الجدولة',
    schedule: 'جدولة',
    duplicateArticle: 'نسخ المقال',
    moveToArchive: 'نقل إلى الأرشيف',
    unpublish: 'إلغاء النشر',
    deleteArticle: 'حذف المقال',
    status: 'الحالة',
    scheduled: 'مجدول',
    unsavedChanges: 'لديك تغييرات غير محفوظة',
    keyboardShortcuts: 'اختصارات لوحة المفاتيح',
    save: 'حفظ',
    switchLanguage: 'تبديل اللغة',
    imageInserted: 'تم إدراج الصورة بنجاح',
    featuredImageUploaded: 'تم رفع الصورة المميزة بنجاح',
    articleSaved: 'تم حفظ المقال بنجاح',
    articlePublished: 'تم نشر المقال بنجاح',
    articleScheduled: 'تم جدولة المقال لـ {date}',
    fillTitleAndContent: 'يرجى ملء العنوان والمحتوى قبل النشر',
    selectCategory: 'يرجى اختيار الفئة قبل النشر',
    selectPublicationDate: 'يرجى اختيار تاريخ النشر',
    addContentToPreview: 'أضف بعض المحتوى لمعاينة المقال',
    failedToSave: 'فشل حفظ المقال',
    failedToPublish: 'فشل نشر المقال',
    failedToSchedule: 'فشل جدولة المقال'
  },

  // Article Settings
  articleSettings: {
    publicationSettings: 'إعدادات النشر',
    category: 'الفئة',
    selectCategory: 'اختر فئة المقال',
    author: 'الكاتب',
    selectAuthor: 'اختر الكاتب',
    status: 'الحالة',
    selectStatus: 'اختر الحالة',
    publicationDate: 'تاريخ النشر',
    leaveEmptyToPublishImmediately: 'اتركه فارغاً للنشر فوراً',
    featuredImage: 'الصورة المميزة',
    uploadFeaturedImage: 'قم برفع صورة مميزة لمقالك',
    chooseImage: 'اختر صورة',
    crop: 'قص',
    remove: 'إزالة',
    imageDimensions: 'أبعاد الصورة: 1200x630 بكسل (موصى به)',
    fileSize: 'حجم الملف',
    seoMetadata: 'SEO والبيانات الوصفية',
    metaTitle: 'عنوان Meta',
    metaTitlePlaceholder: 'عنوان محسّن لمحركات البحث (60 حرفاً كحد أقصى)',
    metaTitleDescription: 'سيظهر هذا العنوان في نتائج البحث',
    metaDescription: 'وصف Meta',
    metaDescriptionPlaceholder: 'وصف موجز لمحركات البحث (160 حرفاً كحد أقصى)',
    metaDescriptionDescription: 'سيظهر هذا الوصف في نتائج البحث',
    characters: 'حرف',
    tags: 'العلامات',
    tagsPlaceholder: 'أدخل العلامات مفصولة بفواصل',
    tagsDescription: 'تساعد العلامات في تصنيف والبحث عن المقالات',
    articleStatistics: 'إحصائيات المقال',
    views: 'المشاهدات',
    comments: 'التعليقات',
    created: 'تم الإنشاء',
    lastModified: 'آخر تعديل',
    autoSaved: 'تم الحفظ التلقائي: للتو'
  },

  // Auto Save Indicator
  autoSave: {
    saving: 'جاري الحفظ...',
    unsavedChanges: 'تغييرات غير محفوظة',
    saved: 'تم الحفظ {timeAgo}',
    justNow: 'للتو',
    minAgo: 'منذ {minutes} دقيقة',
    hoursAgo: 'منذ {hours} ساعة',
    hourAgo: 'منذ ساعة'
  },

  // Office Form
  officeForm: {
    title: 'إنشاء منصب مكتبي جديد',
    description: 'إضافة منصب تنظيمي جديد بمعلومات مفصلة',
    step: 'الخطوة',
    of: 'من',
    complete: 'مكتمل',
    categoryBasicInfo: 'الفئة والمعلومات الأساسية',
    categoryBasicInfoDesc: 'اختر الفئة وأدخل معلومات المنصب الأساسية',
    profileBiography: 'الملف الشخصي والسيرة الذاتية',
    profileBiographyDesc: 'قم برفع صورة الملف الشخصي واكتب السيرة الذاتية',
    contactInformation: 'معلومات الاتصال',
    contactInformationDesc: 'أضف طرق الاتصال وتفاصيل التواصل',
    positionSettings: 'إعدادات المنصب',
    positionSettingsDesc: 'قم بتكوين الإعدادات الخاصة بالفئة والتفضيلات',
    reviewPublish: 'المراجعة والنشر',
    reviewPublishDesc: 'راجع جميع المعلومات وانشر المنصب',
    positionSummary: 'ملخص المنصب',
    category: 'الفئة',
    nameArabic: 'الاسم (عربي)',
    nameEnglish: 'الاسم (إنجليزي)',
    contactMethods: 'طرق الاتصال',
    previous: 'السابق',
    next: 'التالي',
    formProgress: 'تقدم النموذج',
    completedSteps: 'الخطوات المكتملة',
    requiredFields: 'الحقول المطلوبة',
    languages: 'اللغات',
    needHelp: 'تحتاج مساعدة؟',
    helpDescription: 'اتصل بفريق الإدارة إذا كنت تحتاج مساعدة في إنشاء المناصب المكتبية.',
    viewDocumentation: 'عرض الوثائق',
    step1Tip1: '• اختر الفئة المناسبة أولاً',
    step1Tip2: '• املأ الأسماء العربية والإنجليزية',
    step1Tip3: '• استخدم عناوين المناصب الرسمية',
    step2Tip1: '• قم برفع صورة ملف شخصي احترافية',
    step2Tip2: '• اكتب سيرة ذاتية مفصلة بالعربية',
    step2Tip3: '• أضف المؤهلات والخبرة',
    step3Tip1: '• أضف طريقة اتصال واحدة على الأقل',
    step3Tip2: '• استخدم عناوين البريد الإلكتروني الرسمية للاتحاد',
    step3Tip3: '• تحقق من جميع معلومات الاتصال',
    step4Tip1: '• قم بتكوين الإعدادات الخاصة بالفئة',
    step4Tip2: '• حدد الصلاحيات المناسبة',
    step4Tip3: '• حدد المسؤوليات بوضوح',
    step5Tip1: '• راجع جميع المعلومات بعناية',
    step5Tip2: '• احفظ كمسودة أو انشر مباشرة',
    step5Tip3: '• معاينة قبل النشر',
    officePositionPublished: 'تم نشر المنصب المكتبي بنجاح!',
    positionVisibleOnWebsite: 'المنصب مرئي الآن على الموقع',
    viewPosition: 'عرض المنصب',
    draftSaved: 'تم حفظ المسودة بنجاح',
    failedToSave: 'فشل حفظ المنصب المكتبي. يرجى المحاولة مرة أخرى.',
    previewOpened: 'تم فتح المعاينة في نافذة جديدة',
    profileImageUploaded: 'تم رفع صورة الملف الشخصي بنجاح',
    profileImageRemoved: 'تم إزالة صورة الملف الشخصي',
    pleaseSelectCategory: 'يرجى اختيار فئة المنصب',
    arabicNameRequired: 'الاسم العربي مطلوب',
    englishNameRequired: 'الاسم الإنجليزي مطلوب',
    arabicTitleRequired: 'العنوان العربي مطلوب',
    englishTitleRequired: 'العنوان الإنجليزي مطلوب',
    arabicBiographyRequired: 'السيرة الذاتية العربية مطلوبة',
    atLeastOneContact: 'طريقة اتصال واحدة على الأقل مطلوبة',
    fixValidationErrors: 'يرجى إصلاح أخطاء التحقق قبل النشر',
    unsavedChangesConfirm: 'لديك تغييرات غير محفوظة. هل أنت متأكد أنك تريد المغادرة دون حفظ؟'
  },

  // Office Form Components
  officeFormComponents: {
    officeCategory: 'فئة المكتب',
    selectOrganizationalCategory: 'اختر الفئة التنظيمية لهذا المنصب',
    positionCategory: 'فئة المنصب',
    chooseAppropriateCategory: 'اختر الفئة المناسبة لهذا المنصب المكتبي',
    selectCategory: 'اختر فئة...',
    boardMembers: 'أعضاء المجلس',
    boardMembersDesc: 'مناصب المجلس التنفيذي وأدوار القيادة',
    supervisoryCommittee: 'اللجنة الإشرافية',
    supervisoryCommitteeDesc: 'مناصب الإشراف والمراقبة',
    electoralCommittee: 'اللجنة الانتخابية',
    electoralCommitteeDesc: 'أدوار إدارة الانتخابات والتنسيق',
    generalAssembly: 'الهيئة العمومية',
    generalAssemblyDesc: 'مناصب الهيئة العمومية',
    administrativeOffices: 'المكاتب الإدارية',
    administrativeOfficesDesc: 'المناصب التشغيلية والإدارية',
    primaryEmail: 'البريد الإلكتروني الأساسي',
    saving: 'جاري الحفظ...',
    changesSaved: 'تم حفظ التغييرات',
    lastSaved: 'آخر حفظ',
    formValidationStatus: 'حالة التحقق من النموذج',
    allRequiredFieldsCompleted: 'تم إكمال جميع الحقول المطلوبة. جاهز للنشر!',
    requiredFieldsNeedAttention: '{missing} من {total} حقول مطلوبة تحتاج إلى الاهتمام',
    completeAllRequiredFields: 'أكمل جميع الحقول المطلوبة لتمكين النشر',
    publishPosition: 'نشر المنصب',
    backToOffices: 'العودة إلى المكاتب',
    viewAllOffices: 'عرض جميع المكاتب',
    dashboard: 'لوحة التحكم',
    keyboardShortcuts: 'اختصارات لوحة المفاتيح',
    ctrlS: 'Ctrl + S: حفظ المسودة',
    ctrlP: 'Ctrl + P: معاينة',
    ctrlEnter: 'Ctrl + Enter: نشر',
    esc: 'Esc: إلغاء',
    // Biography Editor
    biographyAndDescription: 'السيرة الذاتية والوصف',
    provideDetailedInformation: 'قدم معلومات مفصلة عن صاحب المنصب',
    collapse: 'طي',
    expand: 'توسيع',
    bold: 'عريض (Ctrl+B)',
    italic: 'مائل (Ctrl+I)',
    bulletList: 'قائمة نقطية',
    words: 'كلمات',
    biographyDescription: 'السيرة الذاتية / الوصف',
    enterDetailedBiography: 'أدخل سيرة ذاتية ووصفاً مفصلاً بـ {language}...',
    writingGuidelines: 'إرشادات الكتابة:',
    guideline1: '• تضمين الخلفية التعليمية والمؤهلات',
    guideline2: '• ذكر الخبرة العملية والإنجازات ذات الصلة',
    guideline3: '• إبراز المهارات ومجالات الخبرة',
    guideline4: '• إضافة الاهتمامات الشخصية أو المشاركة المجتمعية',
    guideline5: '• الحفاظ على نبرة احترافية ولكن ودودة',
    guideline6: '• الهدف من 100-300 كلمة للقراءة المثلى',
    noContent: 'لا يوجد محتوى',
    // Contact Information
    contactInformation: 'معلومات الاتصال',
    addMultipleContactMethods: 'أضف طرق اتصال متعددة لهذا المنصب',
    contactType: 'نوع الاتصال',
    labelOptional: 'التسمية (اختياري)',
    labelPlaceholder: 'مثال: بريد العمل، الهاتف الشخصي',
    removeContact: 'إزالة الاتصال',
    addAnotherContactMethod: 'إضافة طريقة اتصال أخرى',
    contactGuidelines: 'إرشادات الاتصال:',
    contactGuideline1: '• طريقة اتصال واحدة على الأقل مطلوبة',
    contactGuideline2: '• استخدم عناوين البريد الإلكتروني الرسمية للاتحاد عند التوفر',
    contactGuideline3: '• قم بتضمين رمز البلد لأرقام الهاتف (+90 لتركيا)',
    contactGuideline4: '• تحقق من جميع معلومات الاتصال قبل الحفظ',
    contactGuideline5: '• معلومات الاتصال الشخصية ستُعرض علناً',
    contactSummary: 'ملخص الاتصال:',
    emailAddress: 'عنوان البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    mobilePhone: 'الهاتف المحمول',
    whatsapp: 'واتساب',
    telegram: 'تيليجرام',
    linkedin: 'لينكد إن',
    twitter: 'تويتر/X',
    personalWebsite: 'الموقع الشخصي',
    invalidEmailFormat: 'تنسيق البريد الإلكتروني غير صحيح',
    invalidPhoneFormat: 'تنسيق رقم الهاتف غير صحيح',
    invalidUrlFormat: 'يجب أن يبدأ الرابط بـ http:// أو https://',
    // Multilingual Name Fields
    positionInformation: 'معلومات المنصب',
    enterPositionDetails: 'أدخل تفاصيل المنصب بلغات متعددة',
    editingIn: 'التحرير بـ {language}',
    rightToLeftText: 'نص من اليمين إلى اليسار',
    leftToRightText: 'نص من اليسار إلى اليمين',
    positionName: 'اسم المنصب',
    enterPositionName: 'أدخل اسم المنصب بـ {language}',
    positionTitle: 'عنوان المنصب',
    enterOfficialTitle: 'أدخل العنوان الرسمي بـ {language}',
    departmentDivision: 'القسم/الشعبة',
    enterDepartmentName: 'أدخل اسم القسم بـ {language}',
    translationProgress: 'تقدم الترجمة',
    languages: 'اللغات',
    // Position Specific Fields
    pleaseSelectCategory: 'يرجى اختيار فئة لتكوين الإعدادات الخاصة بالمنصب',
    boardMemberSettings: 'إعدادات عضو المجلس',
    supervisoryCommitteeSettings: 'إعدادات اللجنة الإشرافية',
    electoralCommitteeSettings: 'إعدادات اللجنة الانتخابية',
    generalAssemblySettings: 'إعدادات الهيئة العمومية',
    administrativeOfficeSettings: 'إعدادات المكتب الإداري',
    positionSettings: 'إعدادات المنصب',
    configureSettingsSpecific: 'قم بتكوين الإعدادات الخاصة بفئة هذا المنصب',
    termDuration: 'مدة المدة',
    howLongIsTerm: 'كم هي مدة فترة المجلس هذه؟',
    selectTermDuration: 'اختر مدة المدة',
    oneYear: 'سنة واحدة',
    twoYears: 'سنتان',
    threeYears: 'ثلاث سنوات',
    fourYears: 'أربع سنوات',
    indefinite: 'غير محدد',
    highPriority: 'أولوية عالية',
    mediumPriority: 'أولوية متوسطة',
    lowPriority: 'أولوية منخفضة',
    termStartDate: 'تاريخ بداية المدة',
    termEndDate: 'تاريخ نهاية المدة',
    leaveEmptyForIndefinite: 'اتركه فارغاً للمدد غير المحددة',
    boardResponsibilities: 'مسؤوليات المجلس',
    strategicPlanning: 'التخطيط الاستراتيجي',
    budgetOversight: 'الإشراف على الميزانية',
    policyDevelopment: 'تطوير السياسات',
    memberRelations: 'علاقات الأعضاء',
    externalRelations: 'العلاقات الخارجية',
    eventPlanning: 'تخطيط الفعاليات',
    priorityLevel: 'مستوى الأولوية',
    whatIsPriorityLevel: 'ما هو مستوى الأولوية لدور الإشراف هذا؟',
    selectPriorityLevel: 'اختر مستوى الأولوية',
    reportingFrequency: 'تكرار التقارير',
    reportingFrequencyPlaceholder: 'مثال: شهرياً، ربع سنوي',
    oversightAreas: 'مجالات الإشراف',
    oversightAreasPlaceholder: 'مثال: المالية، العمليات',
    hasAuditAuthority: 'لديه سلطة التدقيق',
    canConductInternalAudits: 'هل يمكن لهذا المنصب إجراء تدقيقات داخلية؟',
    electionCycle: 'دورة الانتخابات',
    electionCyclePlaceholder: 'مثال: سنوية، كل سنتين',
    nextElectionDate: 'تاريخ الانتخابات القادمة',
    electoralResponsibilities: 'مسؤوليات الانتخابات',
    candidateRegistration: 'تسجيل المرشحين',
    votingProcessManagement: 'إدارة عملية التصويت',
    resultVerification: 'التحقق من النتائج',
    disputeResolution: 'حل النزاعات',
    voterEducation: 'تعليم الناخبين',
    electionSecurity: 'أمن الانتخابات',
    specializationArea: 'مجال التخصص',
    whatIsMainFocusArea: 'ما هو المجال الرئيسي لهذا المكتب؟',
    selectSpecializationArea: 'اختر مجال التخصص',
    academicAffairs: 'الشؤون الأكاديمية',
    studentServices: 'خدمات الطلاب',
    culturalActivities: 'الأنشطة الثقافية',
    sportsRecreation: 'الرياضة والترفيه',
    mediaCommunications: 'الإعلام والاتصالات',
    financeAdministration: 'المالية والإدارة',
    legalAffairs: 'الشؤون القانونية',
    internationalRelations: 'العلاقات الدولية',
    officeHours: 'ساعات العمل',
    officeHoursPlaceholder: 'مثال: الاثنين-الجمعة 9:00-17:00',
    officeLocation: 'موقع المكتب',
    officeLocationPlaceholder: 'مثال: الغرفة 101، المبنى الرئيسي',
    serviceCapabilities: 'قدرات الخدمة',
    studentCounseling: 'استشارة الطلاب',
    documentProcessing: 'معالجة الوثائق',
    informationServices: 'خدمات المعلومات',
    eventCoordination: 'تنسيق الفعاليات',
    technicalSupport: 'الدعم الفني',
    translationServices: 'خدمات الترجمة',
    additionalSettings: 'إعدادات إضافية',
    publicContactInformation: 'معلومات الاتصال العامة',
    displayContactInfo: 'عرض معلومات الاتصال على الموقع العام',
    activePosition: 'منصب نشط',
    positionIsActive: 'المنصب نشط حالياً ويعمل',
    displayOrder: 'ترتيب العرض',
    lowerNumbersAppearFirst: 'الأرقام الأقل تظهر أولاً في القوائم',
    displayOrderPlaceholder: 'مثال: 1، 2، 3...',
    // Profile Image Upload
    profileImage: 'صورة الملف الشخصي',
    uploadProfessionalPhoto: 'قم برفع صورة ملف شخصي احترافية',
    profilePhotoAlt: 'صورة ملف شخصي لصاحب المنصب المكتبي',
    currentImage: 'الصورة الحالية',
    clickXToRemove: 'انقر على زر X لإزالة أو ارفع صورة جديدة للاستبدال',
    replaceImage: 'استبدال الصورة',
    uploadingImage: 'جاري رفع الصورة...',
    uploadProfileImage: 'رفع صورة الملف الشخصي',
    dragAndDropImage: 'اسحب وأفلت صورة هنا، أو انقر للتصفح',
    chooseFile: 'اختر ملف',
    recommendedSize: '• الحجم الموصى به: 400x400 بكسل أو أكبر',
    supportedFormats: '• التنسيقات المدعومة: JPG، PNG، WebP',
    maximumFileSize: '• الحد الأقصى لحجم الملف: 5MB',
    useProfessionalHeadshot: '• استخدم صورة شخصية احترافية وواضحة',
    pleaseSelectValidImage: 'يرجى اختيار ملف صورة صحيح',
    fileSizeMustBeLess: 'يجب أن يكون حجم الملف أقل من 5MB'
  }
};

// Translation function
export const t = (key, params = {}) => {
  const keys = key.split('.');
  let value = translations;
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
  }
  
  if (typeof value !== 'string') {
    console.warn(`Translation value is not a string: ${key}`);
    return key;
  }
  
  // Simple parameter replacement
  return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
    return params[paramKey] !== undefined ? params[paramKey] : match;
  });
};

// React hook for translations
export const useTranslation = () => {
  return { t };
};

export default translations;

